const createService = {
  select: 'SELECIONAR',
  step0: 'Selecione o Equipamento',
  step1: 'Selecione o Tipo de Serviço',
  step2: 'Complete o Checklist',
  draftListTitle: 'Rascunhos de Serviços',
  draftListDescription: 'Existem serviços similares já iniciados e não finalizados para este equipamento',
  draftListButton: 'VISUALIZAR',
  toastrSucessDeleteDraftTitle: 'Rascunho deletado com sucesso',
  toastrErrorDeleteDraftTitle: 'Erro ao deletar rascunho',
  savingDraft: 'Salvando rascunho...',
  lastSavedDraft: 'Último rascunho salvo ' 
};

export default createService;